export const bitwiseNot = (bool) => +!bool

export const toInt = (number, radix = 10) => parseInt(number, radix)
